var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTdsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 0H4.58036C0.91219 0 0 0.980119 0 4.89089V15.8178C0 18.3991 1.41681 19.0104 3.13444 17.1666L3.14415 17.1569C3.93989 16.3127 5.1529 16.3806 5.8419 17.3025L6.82207 18.6126C7.6081 19.6509 8.87935 19.6509 9.66538 18.6126L10.6455 17.3025C11.3442 16.3709 12.5572 16.303 13.353 17.1569C15.0803 19.0007 16.4874 18.3894 16.4874 15.8081V4.89089C16.4971 0.980119 15.5849 0 11.9167 0ZM5.33728 4.85208C5.87101 4.85208 6.30775 5.28876 6.30775 5.82249C6.30775 6.35622 5.88072 6.79291 5.33728 6.79291C4.79385 6.79291 4.36687 6.35622 4.36687 5.82249C4.36687 5.28876 4.79385 4.85208 5.33728 4.85208ZM11.1598 11.645C10.6164 11.645 10.1894 11.2083 10.1894 10.6746C10.1894 10.1408 10.6261 9.70415 11.1598 9.70415C11.6936 9.70415 12.1302 10.1408 12.1302 10.6746C12.1302 11.2083 11.7033 11.645 11.1598 11.645ZM12.0332 5.42462L5.50225 11.9555C5.35669 12.1011 5.17231 12.169 4.98793 12.169C4.80355 12.169 4.61918 12.1011 4.47361 11.9555C4.19219 11.6741 4.19219 11.2083 4.47361 10.9269L11.0046 4.39598C11.286 4.11456 11.7518 4.11456 12.0332 4.39598C12.3146 4.6774 12.3146 5.1432 12.0332 5.42462Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdsIcon);
export default __webpack_public_path__ + "static/media/tds_icon.abb8c5959bcab38d43dcc124b805cab3.svg";
export { ForwardRef as ReactComponent };